import { Box } from '@wix/design-system';
import React from 'react';
import { useValidChildren } from '../../../hooks/useValidChildren';
import { ProductCardElevation } from './ProductCard.types';
import { ProductCardButton } from './ProductCardButton';
import { ProductCardContent } from './ProductCardContent';
import { ProductCardFeatureList } from './ProductCardFeatureList';
import { ProductCardHeader } from './ProductCardHeader';
import { ProductCardPrice } from './ProductCardPrice';
import { ProductCardSeparator } from './ProductCardSeparator';
import { ProductCardTag } from './ProductCardTag';
const DEFAULT_BORDER_COLOR = '#DFE5EB';
const DEFAULT_BORDER = `1px solid ${DEFAULT_BORDER_COLOR}`;
const getStyleProps = ({ shadow, elevation, borderRight = DEFAULT_BORDER, borderLeft = DEFAULT_BORDER, }) => {
    // TODO: Fix how we handle borders (and other props). It throws a react warning
    const elevationHeight = ProductCardElevation[elevation ?? 'None'];
    return {
        boxShadow: shadow
            ? `0px ${shadow?.showOnTopAndBottom ? 0 : elevationHeight}px 30px 5px ${shadow?.color}`
            : '',
        clipPath: !shadow?.showOnTopAndBottom ? 'inset(0px -150px 0px -150px)' : '',
        zIndex: shadow ? 2 : elevationHeight ? 1 : 0,
        borderTop: elevationHeight ? 'none' : DEFAULT_BORDER,
        borderBottom: DEFAULT_BORDER,
        borderRight: elevationHeight || shadow ? 'none' : borderRight,
        borderLeft: elevationHeight || shadow ? 'none' : borderLeft,
        borderColor: DEFAULT_BORDER_COLOR,
    };
};
const modifyChildren = (children, options) => {
    let tag;
    const bodyComponents = [];
    children.forEach((child) => {
        if (child.type === ProductCardTag) {
            tag = React.cloneElement(child, {
                marginBottom: `${ProductCardElevation[options.elevation ?? 'None']}px`,
            });
        }
        else {
            bodyComponents.push(child);
        }
    });
    return { tag, bodyComponents };
};
const VALID_ELEMENT_TYPES = [
    ProductCardTag,
    ProductCardHeader,
    ProductCardButton,
    ProductCardSeparator,
    ProductCardFeatureList,
    ProductCardPrice,
    ProductCardContent,
];
const ProductCard = ({ children, className, dataHook, width, height = '580px', elevation = 'None', borderLeft, borderRight, shadow, backgroundColor = 'white', ...props }) => {
    const validChildren = useValidChildren(children, VALID_ELEMENT_TYPES, () => {
        return `ProductCard only accepts [${VALID_ELEMENT_TYPES.map((et) => et.name)}] as children. Got invalid child:`;
    });
    const { tag, bodyComponents } = modifyChildren(validChildren, { elevation });
    const styleProps = getStyleProps({
        shadow,
        elevation,
        borderLeft,
        borderRight,
    });
    return (React.createElement(Box, { className: className, dataHook: dataHook, align: "center", alignContent: "space-between", boxSizing: "border-box", ...styleProps, ...props, flex: 1, height: `calc(${height} + ${ProductCardElevation[elevation]}px)`, width: width, backgroundColor: backgroundColor, direction: "vertical" },
        tag,
        bodyComponents));
};
ProductCard.Tag = ProductCardTag;
ProductCard.Header = ProductCardHeader;
ProductCard.Button = ProductCardButton;
ProductCard.Separator = ProductCardSeparator;
ProductCard.FeatureList = ProductCardFeatureList;
ProductCard.Price = ProductCardPrice;
ProductCard.Content = ProductCardContent;
export default ProductCard;
//# sourceMappingURL=ProductCard.js.map